export const GET_INVENTORY_DASHBOARD_SUMMARY = 'GET_INVENTORY_DASHBOARD_SUMMARY'
